import { useAuthentication } from "@app/store/useAuthtentication";
import { useQuery } from "@tanstack/react-query";
import {
  topInventoryOutReportService,
  downloadTopInventoryOutReportExcel
} from "./topInventoryOutReport";
import type { ITopInventoryOutReportFilters } from "./types";

export function useGetTopInventoryOutReport(
  filters: ITopInventoryOutReportFilters,
  enabled = true
) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  return useQuery({
    enabled,
    gcTime: 0,
    queryKey: [
      "topInventoryOutReport",
      filters.startDate,
      filters.endDate,
      filters.page,
      filters.perpage,
      filters.siteIds,
      filters.warehouseName,
      filters.deliveredBy
    ],
    queryFn: async () => await topInventoryOutReportService(filters, token)
  });
}

export function useDownloadTopInventoryOutReportExcel(filters: ITopInventoryOutReportFilters) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  return useQuery({
    enabled: false,
    gcTime: 0,
    queryKey: ["topInventoryOutReportExcel", filters],
    queryFn: async () => await downloadTopInventoryOutReportExcel(filters, token)
  });
}
